<template>
<div class="chapter">
<div class="inner_page">
<div class="part-box" id="part01">
<p class="ch-image"><img alt="image" src="images/ch.jpg"/></p>
<h2 class="part-title">I. FLOUNDERING:<br/>WHY WORK FAILS US</h2>
<p class="ch-image"><img alt="image" src="images/ch.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?20c950b2